const firePriceChange = (el: HTMLElement): void => {
  el.dispatchEvent(new Event('blubolt:priceChange', {bubbles: true} ))
}

export default firePriceChange